import * as Api from '@ViewModels';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { buildContactQuery } from './useContact';
import { invalidateAllContactFilterQueries } from './useContactFilterQuery';

export function useContactToggleTextSubscriptionMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.IContact, variables: { contactId: string; unsubscribe: boolean }) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async ({ contactId, unsubscribe }: { contactId: string; unsubscribe: boolean }) => {
			return userSession.webServiceHelper.callAsync<Api.IContact>(
				`contact/${contactId}/metadata/automatedSMSOptOut`,
				unsubscribe ? 'PUT' : 'DELETE',
				null
			);
		},
		onSuccess: (data, variables) => {
			const contactQueryKey = buildContactQuery({
				contactId: variables.contactId,
				allowArchived: false,
				expandHouseholdMembers: false,
			});
			queryClient.invalidateQueries({ queryKey: contactQueryKey });
			invalidateAllContactFilterQueries();

			onSuccess?.(data, variables);
		},
		onError,
	});
}
